import { CompanyType } from 'app/shared/model/enumerations/company-type.model';

export interface ICompany {
  id?: number;
  name?: string | null;
  type?: CompanyType | null;
  activated?: boolean | null;
  logoContentType?: string | null;
  logo?: string | null;
  logoUrl?: string | null;
  identification?: string | null;
}

export const defaultValue: Readonly<ICompany> = {
  activated: false,
};
